function SocialCard({ socialData }: any) {
  const { name, socialTag, url } = socialData;
  return (
    <div className="pt-4 flex justify-start items-center text-black text-lg md:text-xl font-light">
      <p className="text-black font-black">{`${name}:`}</p>
      <p >&nbsp;@</p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 decoration-black"
      >
    {socialTag}
      </a>
    </div>
  );
}

export default SocialCard;
